module.exports = __webpack_public_path__ + "static/media/mil5order.a9591e82.png";